/**
 * @desc 申请预支付接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/applyPay',
    data: params,
    method: 'post',
  })
}
